'use strict';

var DocumentObserver = require('./DocumentObserver.js');
var loadScript = require('./loadScript.js');
var loadStyle = require('./loadStyle.js');

/**
 * @class
 * @classdesc
 * Style blocks of example code.
 * And dynamically load JS and CSS for styling code
 * 
 * @param styleClass
 */
function LiveStyleCodeBlocks() {
	// Bind methods to 'this'
	this._onAdded = this._onAdded.bind(this);
	
	// Observe instances of elements styleClass as they are created, or removed
	DocumentObserver.getInstance().onStyleClass(
		'styleCode',
		this._onAdded
	);
}

/**
 * @public
 * @param elem {Element[]}
 */
LiveStyleCodeBlocks.prototype._onAdded = function(elems) {
	for (var i = 0, len = elems.length, elem; i < len; i++) {
		initStyleCode(elems[i]);
	}
}

var isResourcesLoaded = false,
	isLoadingResource = false;
function initStyleCode(elem) {
	if (isResourcesLoaded === true) {
		style(elem);
	} else {
		addToQueue(elem);
		if (isLoadingResource === false) {
			loadResources();
		}
	}
}
function style(elem) {
	window.hljs.highlightBlock(elem);
}

function loadResources() {
	isLoadingResource = true;
	loadStyle('/assets/theme/highlightjs/monokai-sublime.css');
	loadScript('/assets/theme/highlightjs/script.js', function() {
		isResourcesLoaded = true;
		processQueue();
	});
}

var queue = null;
function addToQueue(elem) {
	if (queue === null) {
		queue = new Array();
	}
	queue.push(elem);
}
function processQueue() {
	for (var i = 0, len = queue.length; i < len; i++) {
		style(queue[i]);
	}
	queue = null;
}


module.exports = LiveStyleCodeBlocks;

